﻿/** 
 * Multi Asset Blocks
 * 
 * @class rlMultiAsset
 * @memberOf jQuery.fn
 */

(function ($) {
    $.fn.rlMultiAsset = function () {
        var multiassetcontainercount = 0;
        $('.multi-asset-container-block').each(function () {
            multiassetcontainercount++;
            $(this).attr('id', 'multi-asset-container-block' + multiassetcontainercount);

            const multiassetitem = $(this).find('.child');
            const flexboxlength = multiassetitem.length;

            if (flexboxlength === 1) {
                multiassetitem.addClass('width50 marginauto');
            }
            else if (flexboxlength === 2 || flexboxlength === 4) {
                multiassetitem.addClass('width50');
                $(this).find('.child:nth-child(odd) .multi-asset-item').addClass('marginrightzero');
                $(this).find('.child:nth-child(even) .multi-asset-item').addClass('marginleftzero');
            }
            else if (flexboxlength >= 5) {
                resetclasses(this);

                var arethereorphans = flexboxlength / 3,
                    decimalpoint = arethereorphans.toString().indexOf('.'),
                    howmanyonlastrow = Number(decimalpoint),
                    howmanyonlastrow = howmanyonlastrow + 1;

                if (decimalpoint != -1) {
                    var numberafterdecimal = arethereorphans.toString().charAt(howmanyonlastrow);

                    if (numberafterdecimal === '3') { oneinlastrow(this); }
                    else if (numberafterdecimal === '6') { twoinlastrow(this); }
                }
            }
            else { resetclasses(); }


            /////////////
            //functions
            /////////////
            function resetclasses(el) {
                $(el).find('.child').removeClass('width33 width50 marginauto marginleftzero marginrightzero').find('.multi-asset-item').removeClass('marginauto marginleftzero marginrightzero');
            }
            function oneinlastrow(el) {
                $(el).find('.child:last-of-type').addClass('width33 marginauto');
            }
            function twoinlastrow(el) {
                $(el).find('.child:last-of-type, .child:nth-last-child(2)').addClass('width33 marginauto');
                $(el).find('.child:last-of-type').addClass('marginleftzero');
                $(el).find('.child:nth-last-child(2)').addClass('marginrightzero');
            }

        });

        //////////////
        //match height
        //////////////
        $('.multi-asset-container-block .img-container').matchHeight();
        $('.multi-asset-container-block .title').matchHeight();
        $('.multi-asset-container-block .title-intro-container').matchHeight();


    }
}(jQuery));